import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmHouseIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmHouseIcon = ({ className, ...props }: EmHouseIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.29311 8.41157V4.91219L3.01123 4.92938V2.77407L5.73029 2.75688V4.87954H5.44842V6.93516L3.29311 8.41157Z"
      fill="#AB5832"
    />
    <path
      d="M11.0187 4.00984L3.20874 11.8577L3.2689 19.1125L18.6947 18.9664L18.717 11.232L11.0187 4.00984Z"
      fill="#FFF3E1"
    />
    <path
      d="M2.91675 17.8389L3.45644 17.5416V11.6841L2.95456 12.0192C2.95284 12.0192 3.00956 17.8389 2.91675 17.8389Z"
      fill="#5F4E47"
    />
    <path
      d="M18.425 12.0003V17.5055L18.9647 17.8028V12.2048L18.425 12.0003Z"
      fill="#5F4E47"
    />
    <path
      d="M11.0721 4.84858L2.95276 12.4472V10.5308L11.0807 2.83249L18.9646 10.9966V12.6139L11.0721 4.84858Z"
      fill="#BCAA93"
    />
    <path
      d="M2.157 10.2025L1.68091 11.0808L2.95794 11.0619C2.95794 11.0619 10.9243 3.31375 11.0962 3.30688C11.3042 3.29828 18.9612 11.1977 18.9612 11.1977L20.0939 11.1805L11.5964 2.02641L10.3486 1.94391L2.157 10.2025Z"
      fill="#AB5832"
    />
    <path
      d="M0.687429 10.8608C0.553367 11.0241 0.68571 11.11 0.793992 11.11C0.902273 11.11 2.15009 11.0739 2.15009 11.0739L10.7507 2.70532C10.7507 2.70532 10.9484 2.50251 11.0893 2.50938C11.2423 2.51626 11.4399 2.71047 11.4399 2.71047L20.0818 11.1822C20.0818 11.1822 21.0666 11.1856 21.2231 11.1461C21.3932 11.1048 21.3073 10.9433 21.0976 10.7181C20.9429 10.5514 12.2065 1.90954 12.0621 1.76001C11.6324 1.31657 11.4227 1.05876 11.0171 1.07594C10.6098 1.09313 10.3691 1.39391 9.9618 1.7686C9.84149 1.88204 0.744148 10.792 0.687429 10.8608Z"
      fill="#ED6C31"
    />
    <path
      d="M16.0703 13.8927H17.832V12.4266C17.832 12.1533 17.6103 11.9333 17.3387 11.9333H16.0703V13.8927Z"
      fill="#A6CFD5"
    />
    <path
      d="M15.5409 13.8927V11.9333H14.1659C13.8926 11.9333 13.6726 12.155 13.6726 12.4266V13.8944H15.5409V13.8927Z"
      fill="#A6CFD5"
    />
    <path
      d="M15.5409 14.4495H13.6726V15.8245C13.6726 16.0978 13.8943 16.3178 14.1659 16.3178H15.5409V14.4495Z"
      fill="#A6CFD5"
    />
    <path
      d="M16.0703 14.4495V16.3178H17.3387C17.612 16.3178 17.832 16.0961 17.832 15.8245V14.4495H16.0703Z"
      fill="#A6CFD5"
    />
    <path
      d="M6.31653 13.8927H8.07825V12.4266C8.07825 12.1533 7.85653 11.9333 7.58497 11.9333H6.31653V13.8927Z"
      fill="#A6CFD5"
    />
    <path
      d="M5.7854 13.8927V11.9333H4.4104C4.13711 11.9333 3.91711 12.155 3.91711 12.4266V13.8944H5.7854V13.8927Z"
      fill="#A6CFD5"
    />
    <path
      d="M5.78539 14.4495H3.91882V15.8245C3.91882 16.0978 4.14054 16.3178 4.4121 16.3178H5.7871V14.4495H5.78539Z"
      fill="#A6CFD5"
    />
    <path
      d="M6.31653 14.4495V16.3178H7.58497C7.85825 16.3178 8.07825 16.0961 8.07825 15.8245V14.4495H6.31653Z"
      fill="#A6CFD5"
    />
    <path
      d="M8.65221 18.3442C8.65221 18.3442 8.62642 14.092 8.65221 13.0178C8.67799 11.9453 9.68517 11.0172 10.8522 11.0567C12.296 11.1066 13.0385 11.9178 13.0917 12.9645C13.145 14.0112 13.145 18.4095 13.145 18.4095L8.65221 18.3442Z"
      fill="#D27857"
    />
    <path
      d="M9.1902 18.5745C9.1902 18.5745 9.16957 14.0439 9.1902 13.2051C9.21598 12.1653 9.99973 11.6187 10.9107 11.6703C11.9711 11.7305 12.4954 12.2942 12.5366 13.1141C12.5779 13.9322 12.5779 18.578 12.5779 18.578L9.1902 18.5745Z"
      fill="#AB5932"
    />
    <path
      d="M12.0295 14.8809C12.026 14.135 12.0192 13.4767 12.0089 13.2756C11.9814 12.7342 11.5963 12.3131 10.8487 12.2873C10.2454 12.2667 9.74869 12.7376 9.73494 13.2928C9.72979 13.4973 9.73151 14.1401 9.73494 14.8723L12.0295 14.8809Z"
      fill="#D27857"
    />
    <path
      d="M9.73999 15.718C9.74687 16.7166 9.75546 17.6361 9.75546 17.6361L12.0362 17.643C12.0362 17.643 12.0362 16.7269 12.0328 15.7283L9.73999 15.718Z"
      fill="#D27857"
    />
    <path
      d="M12.0364 15.2642C12.0278 15.5065 12.1258 15.7025 12.4128 15.7025C12.6998 15.7025 12.8047 15.5684 12.8253 15.3089C12.8425 15.0769 12.6827 14.8706 12.4128 14.8878C12.1447 14.9067 12.0433 15.094 12.0364 15.2642Z"
      fill="#FFBA02"
    />
    <path
      d="M13.6831 19.9908C13.6831 19.9908 15.5531 20.0097 16.904 19.9702C18.255 19.9306 19.2329 19.9908 19.434 19.788C19.6351 19.5869 19.6317 17.8733 18.695 17.4092C17.8339 16.983 17.277 17.4161 16.9814 17.4453C16.5912 17.4849 16.1083 17.2425 15.7542 17.2356C14.2915 17.2047 13.7794 18.3545 13.7794 18.3545L13.6831 19.9908Z"
      fill="#728037"
    />
    <path
      d="M2.49742 19.8498C2.65383 19.9959 3.84836 20.0011 5.29039 19.9908C6.73242 19.9805 7.89258 19.9942 7.89258 19.9942L8.13321 18.5384L7.84102 18.2961C7.84102 18.2961 7.87367 17.5673 6.95414 17.3181C6.31821 17.1463 5.76477 17.4298 5.23024 17.4384C4.69571 17.4487 4.20242 17.2064 3.60774 17.3473C3.0543 17.478 2.62289 17.8389 2.44758 18.5677C2.32555 19.073 2.35649 19.7175 2.49742 19.8498Z"
      fill="#728037"
    />
    <path
      d="M7.72046 21.5136L7.73249 19.9925H7.84421L7.84249 18.2978H13.8117L13.7911 19.9925H13.9217V21.4741C13.92 21.4723 7.72046 21.5222 7.72046 21.5136Z"
      fill="#B0B0B0"
    />
    <path
      d="M13.9202 20.8484V21.4724L7.71899 21.5136L7.72415 20.8433L13.9202 20.8484Z"
      fill="#9B9B9B"
    />
    <path
      d="M7.84094 19.3325L13.7964 19.3342V19.9908H7.84094V19.3325Z"
      fill="#9B9B9B"
    />
  </svg>
);

export default EmHouseIcon;
